export default __webpack_public_path__ + "static/media/1Etherfish0.fee46a08.gif";